import { useCallback, useRef } from 'react';

import { debounce } from '../utils/debounce';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounce = <T extends (...args: any[]) => void>(
  fn: T,
  delay: number,
): T => {
  const debouncedFnRef = useRef<ReturnType<typeof debounce>>();

  return useCallback(
    (...args: Parameters<T>) => {
      if (!debouncedFnRef.current) {
        debouncedFnRef.current = debounce(fn, delay);
      }
      return debouncedFnRef.current(...args);
    },
    [fn, delay],
  ) as T;
};
